import React from 'react';
import { Alert, Container, Typography } from '@mui/material';

interface FileManagerAccessDeniedProps {
  reason?: string;
}

/**
 * Standardized access denied component for file manager
 */
export const FileManagerAccessDenied: React.FC<
  FileManagerAccessDeniedProps
> = ({
  reason = 'You do not have permission to access the file manager. Please contact your administrator if you believe this is an error.',
}) => (
  <Container maxWidth="lg" sx={{ mt: 4 }}>
    <Alert severity="error">
      <Typography variant="h6" gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body2">{reason}</Typography>
    </Alert>
  </Container>
);
